import { render, staticRenderFns } from "./ArticleTextEditor.vue?vue&type=template&id=5cd64fad&"
import script from "./ArticleTextEditor.vue?vue&type=script&lang=ts&"
export * from "./ArticleTextEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTextEditor.vue?vue&type=style&index=0&id=5cd64fad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports